import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { PrimaryButton, SecondaryButton } from '../Button';
import MessageBar from '../MessageBar';
import theme from '../../theme';

const PageContainer = styled.div`
  position: fixed;
  bottom: 0px;
  left: 0px;
  right: 0px;
  box-shadow: 0 -2px 8px 0 rgba(0, 0, 0, 0.06);
  z-index: 9;
  background-color: white;
  padding: ${theme('spacing.huge')} 0px;

  @media (max-width: ${theme('layout.pageWidth')}) {
    padding: ${theme('spacing.regular')} 0px;
  }

  @media (max-height: 450px) {
    padding: ${theme('spacing.regular')} 0px;
  }
`;

const InnerContainer = styled.div`
  margin: 0px auto;
  display: flex;
  justify-content: flex-end;
  max-width: ${theme('layout.pageWidth')};

  @media (max-width: ${theme('layout.pageWidth')}) {
    padding: 0px ${theme('spacing.regular')};
  }
`;

const MessageBarContainer = styled.div`
  position: relative;
  top: -${theme('spacing.huge')};

  @media (max-width: ${theme('layout.pageWidth')}) {
    top: -${theme('spacing.regular')};
  }
`;

const StyledSecondaryButton = styled(SecondaryButton)`
  margin-right: ${theme('spacing.regular')};
`;

const BottomBar = ({
  primaryText,
  secondaryText,
  message,
  messageActionText,
  messageFormAction,
  primaryFormAction,
  secondaryFormAction,
  onPrimaryClick,
  onSecondaryClick,
  onMessageAction,bigger,
  ...props
}) => (
  <PageContainer {...props}>
    {message
      ? (
        <MessageBarContainer>
          <MessageBar
            message={message}
            actionText={messageActionText}
            formAction={messageFormAction}
            onAction={onMessageAction}
          />
        </MessageBarContainer>
      ) : null
    }
    <InnerContainer>
      {secondaryText != null ? (
        <StyledSecondaryButton
          title={secondaryText}
          form="page-form"
          formAction={secondaryFormAction}
          onClick={onSecondaryClick}
        />
      ) : null }
      <PrimaryButton
        title={primaryText}
        form="page-form"
        formAction={primaryFormAction}
        onClick={onPrimaryClick}
        bigger={bigger}
      />
    </InnerContainer>
  </PageContainer>
);

BottomBar.propTypes = {
  primaryText: PropTypes.string.isRequired,
  secondaryText: PropTypes.string,
  primaryFormAction: PropTypes.string,
  secondaryFormAction: PropTypes.string,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func,
  message: PropTypes.string,
  messageActionText: PropTypes.string,
  messageFormAction: PropTypes.string,
  onMessageAction: PropTypes.func,
  bigger: PropTypes.bool,
};

BottomBar.defaultProps = {
  secondaryText: null,
  primaryFormAction: null,
  secondaryFormAction: null,
  onSecondaryClick: () => {},
  message: null,
  messageActionText: null,
  messageFormAction: null,
  onMessageAction: () => {},
  bigger:false
};

export const getThemeBottomBarHeight = ({ theme: t }) => `${(parseFloat(t.spacing.huge) * 2) + parseFloat(t.size.button)}px`;

export default BottomBar;
